/**
 * Hueco del topbar donde la vista actual cuelga un dato junto a su título.
 *
 * Lo usa el directorio para el número de investigadores. Es un portal y no un
 * texto en el propio breadcrumb porque el dato tiene su propio formato —una
 * cifra, no una etiqueta más del camino— y porque sólo tiene sentido en el
 * eslabón ACTUAL: al entrar a una ficha, "Investigadores" pasa a ser un enlace
 * del camino y el número ahí sobra. Al desmontarse la vista, el hueco se vacía
 * solo y el CSS lo colapsa.
 */
export const BREADCRUMB_BADGE_PORTAL_ID = 'breadcrumb-badge-portal';
